import { render } from "./meetingCourse.vue?vue&type=template&id=637abfac"
import script from "./meetingCourse.vue?vue&type=script&lang=js"
export * from "./meetingCourse.vue?vue&type=script&lang=js"

import "./meetingCourse.vue?vue&type=style&index=0&id=637abfac&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__